module.exports = __webpack_public_path__ + "static/media/pet-navy-blue-icon.d2febeab.svg";